export class CapsuleBrand {
  constructor(
    public id: number,
    public name: string,
    public subBrandId: number,
    public subBrandName: string
  ) {}
}
